import Rugby from './components/rugby/rugby';
import Football from './components/football/football';
import Crossfit from './components/crossfit/crossfit';
import Esport from './components/esport/esport';

// import MainRugby from '../main-rugby/main-rugby';

import './intro.css';
import FirstHeader from '../firstheader/firstheader';

const Intro = () => {

    return (
        <>
            <FirstHeader />

            <div className="column-coverer">
                <Rugby />
                <Football />
                <Crossfit />
                <Esport />
            </div>
        </>
    );
}


export default Intro;